import React, { useEffect } from 'react'
import { PRE_CHECK_MACHINE_STATES } from '../constants'
import useStudentPreChecks from '../useStudentPreChecks'
import useWindowEvents from '../useWindowEvents'
import useNetworkSpeedError from './hooks/useNetworkSpeedError'
import runNetworkSpeedTest from './runNetworkSpeedTest'

export default function NetworkSpeedCheck(props){

    const { speechProps } = props

    const studentPreCheck = useStudentPreChecks({itemToCheck: PRE_CHECK_MACHINE_STATES.networkSpeedChecks})
    const { isCurrent, currentError } = studentPreCheck

    useWindowEvents()

    useEffect(()=>{
        if(isCurrent){
            studentPreCheck.startCheck(true)
            performNetworkSpeedChecks()
        }
    }, [isCurrent])

    useNetworkSpeedError({currentError, speechProps})

    const performNetworkSpeedChecks = async () => {
        try{
            await runNetworkSpeedTest()
            studentPreCheck.finishCheck()
        }catch(err){
            //TODO: What are the possible failures that we can handle?
            // Errors should be handled here or retried, only if unable to resolve, then go to failedCheck.
            studentPreCheck.failedCheck(new Error("Network speed check failed", {cause: err}))
        }
    }

    if(!studentPreCheck.isCurrent) return null

    return <div className='invisible'>Loading network speed checks</div>
}